import styled from 'styled-components';
import {bordersStyles} from '../../../../utils/styles';

const StyledExpensesPanel = styled.div`
  display: flex;
  align-items: flex-start;
  padding: 24px;
  position: relative;
  transition: .3s ease-in-out;
  width: 100%;

   .expense-details-panel {
     position: sticky !important;
     top: 90px !important;
     min-height: calc(100vh - 66px - (24px * 2));
     margin-left: 24px;

     .expense-details-tab {
       margin-bottom: 24px;

       &.with-footer {
         margin-bottom: calc(82px + 16px);
       }
     }

     &.full {
       .ant-tabs-content-holder {
         .ant-tabs-content {
           max-height: calc(100vh - 66px - 24px * 2 - 42px);
         }
       }
     }

     &.short {
       .ant-tabs-content-holder {
         .ant-tabs-content {
           max-height: calc(100vh - 66px - 24px * 2 - 42px - 70px);
         }
       }
     }


    .ant-tabs-content-holder {
      min-height: unset;
      padding: 0;

      .ant-tabs-content {
        max-height: calc(100vh - 66px - 24px * 2 - 42px);
        height: 100vh;
        overflow: auto;
        padding: 16px 24px 0 24px;
      }
    }
   }

  .expense-type {
    align-items: center;
    display: flex;

    svg {
      height: 24px;
      width: 24px;

      path {
        fill: ${props => props.theme.colors.neutral_6};
      }
    }
  }
`;

const StyledExpensesPanelContainer = styled.div`
  ${bordersStyles.default};
  background-color: ${props => props.theme.colors.neutral_1};
  padding: 24px;
  flex: none;
`;

export {
  StyledExpensesPanel,
  StyledExpensesPanelContainer,
}
